<template>
  <div class="carousel">
    <div
      class="carousel-window"
      @mouseover="pause"
      @mouseleave="play"
      ref="carouselWindow"
    >
      <div
        class="carousel-track"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <div v-for="(image, index) in images" :key="index" class="carousel-slide">
          <img :src="image" :alt="'Image ' + (index + 1)" />
        </div>
        <div class="banner-dots">
          <!-- 底部小点 -->
          <span
            v-for="(dot, index) in images.length"
            :key="index"
            :class="{ active: activeDot === index }"
          ></span>
        </div>
      </div>
    </div>
    <button @click="prev"><</button> <button @click="next">></button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeDot: 0, // 当前激活的小点索引
      images: [
        require("@/assets/banner1.jpg"),
        require("@/assets/banner2.jpg"),
        require("@/assets/banner3.jpg"),
        require("@/assets/banner1.jpg"),
      ],
      currentIndex: 0,
      interval: null,
    };
  },
  mounted() {
    this.play();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    play() {
      this.stop();
      this.interval = setInterval(this.next, 2000);
    },
    pause() {
      this.stop();
    },
    stop() {
      clearInterval(this.interval);
      this.interval = null;
    },
  },
};
</script>
<style scoped>
.carousel {
  position: relative;
  margin-left: -1vw;
  overflow: hidden;
  width: 100%;
}
.carousel-window {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 600px;
  border: 1px solid #ddd;
  cursor: pointer;
}
.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
}
.carousel-slide {
  min-width: 100%;
  box-sizing: border-box;
}
.carousel-slide img {
  width: 100%;
  display: block;
}
button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}
button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
button:focus {
  outline: none;
}
button:nth-child(2) {
  left: 10px;
}
button:nth-child(3) {
  right: 10px;
}

.banner-dots {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.banner-dots span {
  display: inline-block;
  width: 50px;
  height: 6px;
  border-radius: 1em;
  background-color: #ccc;
  margin: 0 5px;
  opacity: 0.3;
  transition: opacity 0.3s;
  cursor: pointer;
}
.banner-dots .active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/index/Carousel.vue